import "./src/styles/layout.scss";
import "./src/styles/cookie.css";
import "./src/styles/global.scss";
import "@fontsource/inter/latin-300.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/bricolage-grotesque/latin-500.css";
import "@fontsource/bricolage-grotesque/latin-600.css";
import { captureAttribution, trackEvent } from "./src/utils/analytics";

export const onClientEntry = () => {
  captureAttribution();
  document.addEventListener("click", event => {
    const link = event.target.closest?.("a[href]");
    if (!link) return;
    const href = link.getAttribute("href") || "";
    if (/^tel:/i.test(href)) trackEvent("click_phone");
    else if (/^mailto:/i.test(href)) trackEvent("click_email");
    else if (/^(https?:\/\/)?(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\//i.test(href)) trackEvent("click_whatsapp");
  });
};

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  // Keep anchor-link navigation working; all normal page changes start at top.
  if (location.hash) return true;

  return [0, 0];
};

export const onRouteUpdate = ({ location }) => {
  captureAttribution();
  if (typeof window === "undefined" || !window.gaLoaded || typeof window.gtag !== "function") return;
  const route = location.pathname + location.search;
  if (window.influxiveTrackedPath === route) return;
  window.influxiveTrackedPath = route;
  window.gtag("event", "page_view", {
    page_path: location.pathname,
    page_location: location.origin + location.pathname,
  });
};
